import MGridUtil from "../utils/MGridUtil";
export default Vue => {
  Vue.filter("textLengthSet", function(value, max) {
    if (!value) return "";
    if (!max) return value;
    if (value.length <= max) return value;
    if (value.length > max) {
      value = value.substr(0, max);
      return value + "...";
    }
  });
  Vue.filter("strSub", function(value, end) {
    return value.substring(0, end);
  });
  // 定义一个过滤器 保留两位小数
  Vue.filter("setPrice", function(value) {
    value = Number(value);
    return MGridUtil.toFixedTwo(value);
    // return Number(`${Math.round(`${value}e${2}`)}e-${2}`);
  });
  Vue.filter("zeroFill", function(value) {
    if (value == null) {
      return null;
    }
    var value = Math.round(parseFloat(value) * 100) / 100;
    var s = value.toString().split(".");
    if (s.length == 1) {
      value = value.toString() + ".00";
      return value;
    }
    if (s.length > 1) {
      if (s[1].length < 2) {
        value = value.toString() + "0";
      }
      return value;
    }
  });
};



// WEBPACK FOOTER //
// ./src/core/filter.js